import { render, staticRenderFns } from "./CostPricesRuleDetail.vue?vue&type=template&id=7463e426&scoped=true"
import script from "./CostPricesRuleDetail.vue?vue&type=script&lang=js"
export * from "./CostPricesRuleDetail.vue?vue&type=script&lang=js"
import style0 from "./CostPricesRuleDetail.vue?vue&type=style&index=0&id=7463e426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463e426",
  null
  
)

export default component.exports